import { useEffect } from "react";
import { useParams } from "react-router-dom";

const AmpStoriesCard = () => {
  const { storiename } = useParams();

  useEffect(() => {
    if (storiename) {
      window.location.replace(`/amp-story/${storiename}`);
    }
  }, [storiename]);

  return <div>Opening story...</div>;
};

export default AmpStoriesCard;